export const SIDEBAR_PREFERENCES_COOKIE = "sidebar_preferences";
export const LEGACY_SIDEBAR_OPEN_COOKIE = "sidebar_state";

const COOKIE_MAX_AGE = 60 * 60 * 24 * 365;

export type SidebarPreferences = {
  open: boolean;
  categories: Record<string, boolean>;
};

const DEFAULT_PREFERENCES: SidebarPreferences = {
  open: true,
  categories: {},
};

const isCategoryState = (value: unknown): value is Record<string, boolean> =>
  typeof value === "object" && value !== null && !Array.isArray(value);

const parsePreferencesJson = (value: string): SidebarPreferences | null => {
  try {
    const parsed: unknown = JSON.parse(value);

    if (typeof parsed !== "object" || parsed === null) {
      return null;
    }

    const record = parsed as {
      open?: unknown;
      categories?: unknown;
    };

    return {
      open: record.open !== false,
      categories: isCategoryState(record.categories) ? record.categories : {},
    };
  } catch {
    return null;
  }
};

export const parseSidebarPreferences = (
  preferencesCookie: string | undefined,
  legacyOpenCookie?: string,
): SidebarPreferences => {
  if (preferencesCookie) {
    const preferences = parsePreferencesJson(
      decodeURIComponent(preferencesCookie),
    );

    if (preferences) {
      return preferences;
    }
  }

  if (legacyOpenCookie !== undefined) {
    return {
      open: legacyOpenCookie !== "false",
      categories: {},
    };
  }

  return DEFAULT_PREFERENCES;
};

export const writeSidebarPreferencesCookie = (preferences: SidebarPreferences) => {
  if (typeof document === "undefined") {
    return;
  }

  const value = encodeURIComponent(
    JSON.stringify({
      open: preferences.open,
      categories: preferences.categories,
    }),
  );

  document.cookie = `${SIDEBAR_PREFERENCES_COOKIE}=${value}; path=/; max-age=${COOKIE_MAX_AGE}; SameSite=Lax`;
};
